import React, { useState, useEffect } from "react";
import { Frame, ScalingContainer } from "../../../AppStyled";
import { ReactComponent as InfiniteSVG } from "./infinite.svg";

import {
  Title,
  InputBig,
  InputDiv,
  Reset,
  Increase,
  Input,
  ProfitBox,
  AutoRuleBox,
  Bet,
  Opr,
  BetQuantity,
  PlayBtn,
  BackBtn,
  StopOnInput,
} from "./AutoPageStyled";
// import { ReactComponent as Usdsvg } from "./usd.svg";
// import currencies from "../../../lib/currencies/currencies";

// import { MessageFactory } from "../../../lib/messages";

import useBetOperations from "../../spheres/setBet/useBetOperations";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";

import useSound from "use-sound";
import confirmSfx from "../../../audio/confirm.mp3";
import closeSound from "../../../audio/close.mp3";
// import playSound from "../../../audio/play.mp3";
import switchSound from "./switch.mp3";
import { logger } from "../../../lib/logger";

export default function AutoPage({
  bet,
  autoConfigs, // TODO
  handleAutoRollLogic,
  handleAbove,
  handleNotification,
  unBlur,
  betInfo,
  toFix,
  minBet,
  maxBet,
  onfocus,
  h,
  currency,
  scrollable,
  userSettings,
}) {
  const { sound, volume } = userSettings;
  // const [playSFX] = useSound(playSound, { volume });
  const [closeSFX] = useSound(closeSound, { volume });
  // const [forwardSFX] = useSound(forwardSound, { volume });
  const [switchSFX] = useSound(switchSound, { volume });
  const [confirm] = useSound(confirmSfx, { volume });

  const [betInAuto, setbetInAuto] = useState(bet || "");
  const [inputBet, setinputBet] = useState(betInAuto);
  const [ubet, plus, minus, , , handleButtonPress, handleButtonRelease] =
    useBetOperations(
      betInAuto,
      false,
      sound,
      handleNotification,
      toFix,
      minBet,
      maxBet,
      currency,
    );
  useEffect(() => {
    setbetInAuto(ubet);
    setinputBet(ubet);
  }, [ubet]);
  const [numberOfBets, setnumberOfBets] = useState("0");
  const [onWinReset, setonWinReset] = useState("1");
  const [onWinPercent, setonWinPercent] = useState("0");
  const [onLossReset, setonLossReset] = useState("1");
  const [onLossPercent, setonLossPercent] = useState("0");
  const [stopOnProfit, setstopOnProfit] = useState("0");
  const [stopOnLoss, setstopOnLoss] = useState("0");

  const [infinite, setInfinite] = useState(true);

  const handleNumBetBlur = (e) => {
    const n = e.target.value;
    if (n === "" || n === "0") {
      setnumberOfBets("");
      setInfinite(true);
    } else {
      setnumberOfBets(n);
      setInfinite(false);
    }
  };

  useEffect(() => {
    setnumberOfBets(autoConfigs.numberOfBets);
    setonWinReset(autoConfigs.onWinReset);
    setonWinPercent(autoConfigs.onWinPercent);
    setonLossReset(autoConfigs.onLossReset);
    setonLossPercent(autoConfigs.onLossPercent);
    setstopOnProfit((+autoConfigs.stopOnProfit).toFixed(toFix));
    setstopOnLoss((+autoConfigs.stopOnLoss).toFixed(toFix));
  }, [autoConfigs, toFix]);

  const max = maxBet;
  const min = minBet;

  const handleInput = (e) => {
    const reg = /^\d*\.?\d*$/;
    const reg2 = /^[0-9]*$/;
    const name = e.target.name;
    if (
      (reg.test(e.target.value) && e.target.value >= 0) ||
      e.target.value === ""
    ) {
      switch (name) {
        case "numberOfBets":
          if (reg2.test(e.target.value)) setnumberOfBets(e.target.value);
          break;
        case "onWinPercent":
          setonWinReset("0");
          setonWinPercent(e.target.value);
          break;
        case "onLossPercent":
          setonLossReset("0");
          setonLossPercent(e.target.value);
          break;
        case "stopOnProfit":
          setstopOnProfit(e.target.value);
          break;
        case "stopOnLoss":
          setstopOnLoss(e.target.value);
          break;

        default:
          if (
            (reg.test(e.target.value) && e.target.value >= 0) ||
            e.target.value === ""
          ) {
            logger.log(name);
          }

          break;
      }
    }
  };
  const handleClick = (a, b) =>
    a === "win" ? setonWinReset(b) : setonLossReset(b);

  const handleBet = (q) => {
    // const reg = /^-?\d+\.?\d*$/;
    const reg = /^\d*\.?\d*$/;

    const e = q.target.value;
    if (reg.test(e) || e === "") {
      setinputBet(e);
    }
  };
  const handleBlur = (e) => {
    onfocus(false);

    const n = e.target.value;

    if (n < min || n === "" || n === '.') {
      setbetInAuto(min);
      setinputBet(min);
    } else if (n >= max) {
      setbetInAuto(max);
      setinputBet(max);
    } else {
      setbetInAuto(n);
      setinputBet(n);
    }
  };

  const handleStopOnBlur = (e, name) => {
    const n = e.target.value;
    name === 'profit' ? setstopOnProfit((+n).toFixed(toFix)) : setstopOnLoss((+n).toFixed(toFix))
  }
  const startPlay = () => {
    handleAbove(false);
    handleAutoRollLogic([
      betInAuto,
      max,
      onLossReset,
      onLossPercent,
      onWinReset,
      onWinPercent,
      stopOnLoss,
      stopOnProfit,
      numberOfBets,
      toFix,
    ]);
    // Globals.WS.sendMessage(MessageFactory.createMessage(Protocol.BET, +ubet));
  };

  const [animSG, setanimSG] = useState(false);

  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);
  const [clicked, setclicked] = useState(false);
  return (
    <Frame
      className="Frame"
      unBlur={unBlur}
      opacity="true"
      scrollable={scrollable}
    >
      <ScalingContainer className="ScalingContainer" h={h}>
        <AutoRuleBox>
          <Title>NUMBER OF BETS</Title>
          <InputBig
            data-autocomplete
            name="numberOfBets"
            maxLength="4"
            type="text"
            // placeholder={numberOfBets}
            // value={numberOfBets}
            // onFocus={() => onfocus(true)}
            // onBlur={() => onfocus(false)}
            // onChange={handleInput}

            placeholder={
              numberOfBets !== "0" && numberOfBets !== "" ? numberOfBets : ""
            }
            value={
              numberOfBets !== "0" && numberOfBets !== "" ? numberOfBets : ""
            }
            onChange={handleInput}
            onBlur={handleNumBetBlur}
            onFocus={() => setInfinite(false)}
          />
          {(numberOfBets === "" || numberOfBets === "0") && infinite ? (
            <InfiniteSVG className="infinite" />
          ) : null}
        </AutoRuleBox>
        <Title>ON WIN</Title>

        <InputDiv>
          <Reset
            data-testid="test"
            active={onWinReset === "1"}
            onClick={() => {
              if (sound && onWinReset !== "1") switchSFX();
              handleClick("win", "1");
            }}
          // onClick={() => setonWinReset("1")}
          >
            <div className="yellow" />
            <div className="white" />
            <p>RESET</p>
          </Reset>
          <Increase
            id="onwinincrease"
            active={onWinReset === "0"}
            onClick={() => {
              if (sound && onWinReset !== "0") switchSFX();
              handleClick("win", "0");
            }}
          // onClick={() => setonWinReset("0")}
          >
            <div className="yellow" />
            <div className="white" />
            <p>INCREASE BY</p>
          </Increase>
          <div>
            <Input
              name="onWinPercent"
              maxLength="4" /// ?????
              placeholder={onWinPercent}
              value={onWinPercent}
              onChange={handleInput}
            />
            %
          </div>
        </InputDiv>
        <Title>ON LOSS</Title>
        <InputDiv>
          <Reset
            active={onLossReset === "1"}
            onClick={() => {
              if (sound && onLossReset !== "1") switchSFX();
              handleClick("loss", "1");
            }}
          // onClick={() => setonLossReset("1")}
          >
            <div className="yellow" />
            <div className="white" />
            <p>RESET</p>
          </Reset>
          <Increase
            id="onlossincrease"
            active={onLossReset === "0"}
            onClick={() => {
              if (sound && onLossReset !== "0") switchSFX();
              handleClick("loss", "0");
            }}

          // onClick={() => setonLossReset("0")}
          >
            <div className="yellow" />
            <div className="white" />
            <p>INCREASE BY</p>
          </Increase>
          <div>
            <Input
              name="onLossPercent"
              maxLength="4"
              value={onLossPercent}
              onChange={handleInput}
            />
            %
          </div>
        </InputDiv>
        <ProfitBox>
          <AutoRuleBox>
            <Title>STOP ON PROFIT</Title>
            {/* <InputBig
            name="stopOnProfit"
            value={stopOnProfit}
            onChange={handleInput}
          /> */}
            <StopOnInput>
              <p className="currency">
                {currency}
              </p>
              <input
                name="stopOnProfit"
                maxLength="11"
                placeholder={stopOnProfit}
                value={stopOnProfit}
                onChange={handleInput}
                onBlur={(e) => handleStopOnBlur(e, 'profit')}
              />

              {/* <Usdsvg /> */}
            </StopOnInput>
          </AutoRuleBox>
          <AutoRuleBox>
            <Title>STOP ON LOSS</Title>
            {/* <InputBig
            name="stopOnLoss"
            value={stopOnLoss}
            onChange={handleInput}
          /> */}
            <StopOnInput>
              <p className="currency">
                {currency}
              </p>
              <input
                name="stopOnLoss"
                maxLength="11"
                placeholder={stopOnLoss}
                value={stopOnLoss}
                onChange={handleInput}
                onBlur={(e) => handleStopOnBlur(e, 'loss')}
              />
              {/* <Usdsvg /> */}
            </StopOnInput>
          </AutoRuleBox>
        </ProfitBox>
        <Bet>
          <Opr
            minusPress={minusPress}
            onClick={minus}
            onTouchStart={() => {
              setMinusPress(true);
              handleButtonPress("acceleratableMinus");
            }}
            onTouchEnd={() => {
              setMinusPress(false);
              handleButtonRelease();
            }}
            onMouseDown={() => {
              setMinusPress(true);
              handleButtonPress("acceleratableMinus");
            }}
            onMouseUp={() => {
              setMinusPress(false);
              handleButtonRelease();
            }}
            onMouseLeave={() => {
              setMinusPress(false);
              handleButtonRelease();
            }}
          >
            <MinusSVG />
          </Opr>
          <BetQuantity>
            <p className="currency">
              {currency}
            </p>
            <input
              type="text"
              maxLength="8"
              value={inputBet}
              onChange={handleBet}
              onBlur={handleBlur}
              />
          </BetQuantity>
          <Opr
            plusPress={plusPress}
            onClick={plus}
            onTouchStart={() => {
              setPlusPress(true);
              handleButtonPress("acceleratablePlus");
            }}
            onTouchEnd={() => {
              setPlusPress(false);
              handleButtonRelease();
            }}
            onMouseDown={() => {
              setPlusPress(true);
              handleButtonPress("acceleratablePlus");
            }}
            onMouseUp={() => {
              setPlusPress(false);
              handleButtonRelease();
            }}
            onMouseLeave={() => {
              setPlusPress(false);
              handleButtonRelease();
            }}
          >
            <PlusSVG />
          </Opr>
        </Bet>
        <PlayBtn
          onClick={() => {
            if (betInfo.balance >= betInAuto) {
              // if (sound) playSFX();
              if (!clicked) {
                if (sound) confirm();
                setclicked(true);
                setanimSG(true);
                setTimeout(() => {
                  startPlay();
                }, 500);
              }
            } else {
              handleNotification("Not enough balance");
            }
          }}
          animSG={animSG}
          id="startgame"
        >
          <div className="yellow" />
          <div className="white" />
          START GAME
        </PlayBtn>
        <BackBtn
          id="back"
          onClick={() => {
            if (!clicked) {
              setclicked(true);
              setTimeout(() => {
                setclicked(false);
              }, 500);
              if (sound) closeSFX();
              handleAbove(false);
            }
          }}
        >
          BACK
        </BackBtn>
      </ScalingContainer>
    </Frame>
  );
}
